
// should be undefined in production since we need to use the same build for both 
// UAT and staging
export const REACT_APP_SERVER_ROOT = process.env.REACT_APP_SERVER_ROOT || ''

// should be undefined in production since we need to use the same build for both 
// UAT and staging
export const REACT_APP_WS_ROOT = process.env.REACT_APP_WS_ROOT || ''
export const REACT_APP_CDN_ROOT = process.env.REACT_APP_CDN_ROOT || 'https://cdn.oneethos.com'
export const REACT_APP_AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || ''
export const REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || ''
export const REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || ''
export const REACT_APP_ENV = process.env.REACT_APP_ENV || ''
